module.exports = {"513436100":"巴普镇","513436101":"洪溪镇","513436102":"新桥镇","513436103":"牛牛坝镇","513436104":"拉马镇","513436105":"候播乃拖镇","513436106":"候古莫镇","513436200":"觉洛乡","513436201":"井叶特西乡","513436202":"合姑洛乡","513436208":"典补乡","513436217":"九口乡","513436218":"洛俄依甘乡","513436221":"柳洪乡","513436225":"峨曲古乡","513436229":"龙门乡","513436231":"洒库乡","513436235":"瓦候乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513436.json
// module id = 2577
// module chunks = 0